export enum FieldMode { read = 'read', write = 'write' }
